var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdministratorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1808 1.69043L5.91797 6.90376V33.6904H30.1458V1.69043H11.1808Z",
    fill: "#EAF4FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91797 12.2168V7.02344H11.1673",
    fill: "#C5E1F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1673 1.69043V6.88376H5.91797",
    fill: "#7EB3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3922 31.3179L31.5398 24.6179V13.3579H26.8894L24.5407 12.1445L19.6143 12.4712L12.0633 19.9579L10.4414 25.6645L17.9386 31.6512L19.3922 31.3179Z",
    fill: "#C5E1F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1601 12.3645L27.2253 21.4512L18.1601 30.0979L11.3359 25.5512H5.62891V13.6912H7.97766L11.1138 12.1445L18.1601 12.3645Z",
    fill: "#7EB3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2607 26.8329L24.9844 21.5996",
    stroke: "#7EB3FF",
    strokeWidth: 4.52219,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7294 28.7462L22.4531 23.5195",
    stroke: "#7EB3FF",
    strokeWidth: 4.52219,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2049 30.6593L19.9219 25.4326",
    stroke: "#7EB3FF",
    strokeWidth: 4.52219,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6747 32.58L17.3984 27.3467",
    stroke: "#7EB3FF",
    strokeWidth: 4.52219,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80469 26.3778L10.8304 24.3711",
    stroke: "#C5E1F9",
    strokeWidth: 4.52219,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3828 28.4441L14.4988 25.3574",
    stroke: "#C5E1F9",
    strokeWidth: 4.52219,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9531 30.5164L15.9788 28.5098",
    stroke: "#C5E1F9",
    strokeWidth: 4.52219,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5234 32.5851L18.1117 31.0117",
    stroke: "#C5E1F9",
    strokeWidth: 4.52219,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.7188 25.4443H5.62891L5.62891 12.031H1.7188L1.7188 25.4443Z",
    fill: "#0561FC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3633 25.4453H34.2734V12.032H30.3633V25.4453Z",
    fill: "#0561FC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8086 16.852L19.5667 12.1387H24.5468V15.1853H21.4107L19.5061 17.072C19.5061 17.072 15.1451 19.512 14.8086 16.852Z",
    fill: "#C5E1F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministratorIcon);
export default __webpack_public_path__ + "static/media/administrator-icon.7a8c60e611b950927f6c27e900a8186e.svg";
export { ForwardRef as ReactComponent };